import { BrowserModule } from '@angular/platform-browser'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { NgModule } from '@angular/core'
import { OVERLAY_DEFAULT_CONFIG } from '@angular/cdk/overlay'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { HttpClientModule, HttpClient } from '@angular/common/http'
import { RouterModule } from '@angular/router'

import { AppComponent } from './app.component'
import { AngularFireModule } from '@angular/fire/compat'
import { AngularFireDatabaseModule } from '@angular/fire/compat/database'
import '@shared/services/patch-angular-fire-database-injection-context'
import { AngularFireFunctionsModule } from '@angular/fire/compat/functions'
import { AngularFirestoreModule } from '@angular/fire/compat/firestore'
import { AngularFireStorageModule } from '@angular/fire/compat/storage'
import { AngularFireAuthModule } from '@angular/fire/compat/auth'
import 'firebase/compat/auth'
import { TranslateLoader, TranslateModule } from '@ngx-translate/core'
import { TranslateHttpLoader } from '@ngx-translate/http-loader'
import { LoginComponent } from './components/login/login.component'
import { MatToolbarModule } from '@angular/material/toolbar'
import { MatMenuModule } from '@angular/material/menu'
import { MatIconModule } from '@angular/material/icon'
import { MatButtonModule } from '@angular/material/button'
import { AuthGuardService } from './services/guards/auth-guard.service'
import { MatTableModule } from '@angular/material/table'
import { UserManagementComponent } from './components/user-management/user-management.component'
import { AppRoutingModule } from './app.routing'
import { ComponentsModule } from './components/core/components.module'
import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component'
import { environment } from '../src/environments/environment'
import { UiButtonModule } from './components/ui-button/ui-button.module'
import { UserDeleteConfirmationComponent } from './components/user-delete-confirmation/user-delete-confirmation.component'

export const firebaseConfig = environment.firebase

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    UserManagementComponent,
    AdminLayoutComponent,
    UserDeleteConfirmationComponent,
  ],
  imports: [
    BrowserAnimationsModule,
    ComponentsModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    RouterModule,
    AppRoutingModule,
    BrowserModule,
    AngularFireDatabaseModule,
    AngularFireModule.initializeApp(firebaseConfig),
    AngularFireFunctionsModule,
    AngularFirestoreModule,
    AngularFireStorageModule,
    AngularFireAuthModule,
    MatToolbarModule,
    MatTableModule,
    MatMenuModule,
    MatIconModule,
    MatButtonModule,
    UiButtonModule,
    TranslateModule.forRoot({
      defaultLanguage: 'hu',
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    AppRoutingModule,
  ],
  providers: [AuthGuardService, { provide: OVERLAY_DEFAULT_CONFIG, useValue: { usePopover: false } }],
  bootstrap: [AppComponent],
})
export class AppModule {}

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json')
}
